// extracted by mini-css-extract-plugin
export default {"iconButton":"A+6ScQxWxKbyRpMr0LML+A=="};